import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

/**
 * Types de mouvements de fidélité.
 *
 * PURCHASE reste présent pour lire l'historique.
 * Les nouveaux achats ne doivent plus attribuer de points.
 */
export const fidelityTransactionTypeSchema = z.enum([
  "PURCHASE",
  "CREATE_RESUME",
  "COMPLETE_PROFILE",
  "REFERRAL_ACTIVATED",
  "REVIEW_VERIFIED",
  "REDEMPTION",
  "RESUME_DOWNLOADED",
]);

export const fidelityTransactionSchema = z.object({
  id: z.string(),
  accountId: z.string(),

  type: fidelityTransactionTypeSchema,

  points: z.number(),
  balanceBefore: z.number(),
  balanceAfter: z.number(),

  /**
   * Facultatifs pour rester compatibles avec les anciennes
   * réponses et les anciennes écritures.
   */
  idempotencyKey: z.string().nullable().optional(),
  sourceId: z.string().nullable().optional(),
  policyVersion: z.string().nullable().optional(),
  redemptionId: z.string().nullable().optional(),

  createdAt: z.coerce.date(),
});

export class FidelityTransactionDto extends createZodDto(fidelityTransactionSchema) {}
